// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../../node_modules/ngx-bootstrap/datepicker/bs-datepicker.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fix header text placement */
.bs-datepicker-head > bs-datepicker-navigation-view {
  display: flex;
  justify-content: space-around;
}

.form-control.is-invalid {
  border-right-width: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/s1/s1-input-datepicker/s1-input-datepicker.component.scss"],"names":[],"mappings":"AAGA,8BAAA;AACA;EACE,aAAA;EACA,6BAAA;AADF;;AAIA;EACE,uBAAA;AADF","sourcesContent":["// Import module styling\n@import \"~ngx-bootstrap/datepicker/bs-datepicker.css\";\n\n/* Fix header text placement */\n.bs-datepicker-head > bs-datepicker-navigation-view {\n  display: flex;\n  justify-content: space-around;\n}\n\n.form-control.is-invalid {\n  border-right-width: 5px;\n  //background-color: $danger;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
